import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { verifySlotSession, createOneSlotSession, }
  from 'redux/actions/mvp/session.action';
import './detail.scss';
import moment from 'moment/moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
  changeDateLocaleToUTC,
  changeDateUTCToLocale,
  convertToGMTLocal,
  convertToUTC,
  daysOfWeek,
  getEnglishWeekday,
  getTimeRangeUtc,
  formatCalendarBoundRange,
  isLocalDateInCalendarBounds,
  weekdayKeyFromMoment,
} from './helper';
import { TimePicker, Tooltip } from 'antd';
import { I18n } from '../../../../helpers/i18n';
import { getReactCalendarProps } from '../../../../helpers/calendarLocale';
import Modal from 'react-bootstrap4-modal';
import arrowBackIcon from '../../../../static/svg/back.svg';
import warning from '../../../../static/images/mvp/warning.png';

function TopicDetailCreateOneSlot(
  {
    openModal,
    setOpenModal,
    topicId,
    verifySlotSession,
    createOneSlotSession,
    topic
  },
) {
  const [isShowModal, setIsShowModal] = useState(openModal);
  const [activeDateCalendar, setActiveDateCalendar] = useState(null);
  const defaultEndTime = moment('08:00', 'HH:mm').add(topic?.duration || 20, 'minutes').format('HH:mm');
  const [oneSessionTime, setOneSessionTime] = useState({ start: '08:00', end: defaultEndTime });
  const [oneSessionMessages, setOneSessionMessages] = useState('');
  const [oneSessionOverlapWiths, setOneSessionOverlapWiths] = useState([]);
  const [saving, setSaving] = useState(false);
  const calendarRef = useRef(null);

  useEffect(() => {
    setIsShowModal(openModal);
    const defaultEndTime = moment('08:00', 'HH:mm').add(topic?.duration || 20, 'minutes').format('HH:mm');
    setOneSessionTime({ start: '08:00', end: defaultEndTime })
    if (!openModal) {
      setOneSessionOverlapWiths([])
      setOneSessionMessages('')
    }
  }, [openModal]);
  const toastError = (message = I18n.t('something_wrong')) => {
    toast.error(message, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      className: 'toast-error-container toast-error-container-after',
      theme: 'colored',
    });
  };

  const toastSuccess = (message) => {
    toast.success(message, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: 'colored',
      className: 'toast-success-container toast-success-container-after',
    });
  };

  const toggleOpenModal = () => {
    setIsShowModal(!isShowModal);
    setOpenModal(!isShowModal);
  };

  const saveConfig = async () => {
    if (saving) {
      return
    }
    if (!activeDateCalendar) {
      toastError(I18n.t('config_one_session_step_1'));
      return;
    }
    setSaving(true);
    const toMoment = moment(activeDateCalendar);
    let dayOfWeek = weekdayKeyFromMoment(toMoment);
    const { timeSlotEnd, timeSlotStart } = getTimeRangeUtc(toMoment, toMoment);
    const dayOfWeekUTC = changeDateLocaleToUTC(dayOfWeek, oneSessionTime.start);
    let start = convertToUTC(oneSessionTime.start);
    let end = convertToUTC(oneSessionTime.end);
    if (dayOfWeekUTC) {
      dayOfWeek = dayOfWeekUTC;
    }
    const params = {
      startDate: dayOfWeek,
      timeSlotStart: timeSlotStart,
      timeSlotEnd: timeSlotEnd,
      dataTime: [{ start: start, end: end }],
      // topicId: topicId,
    };
    setOneSessionOverlapWiths([])
    const valid = await verifySlotSession(params);
    if (!valid.isValid) {
      const validSlot = valid.dataTime ? valid.dataTime[0] : null;
      if (validSlot?.isValidStartBeforeEnd === false) {
        setOneSessionMessages(I18n.t('session_st_before_et'))
      }

      if (validSlot?.isValidOverlap === false) {
        setOneSessionMessages(I18n.t('session_date_time_error'))
      }
      if (validSlot?.overlapWiths?.length) {
        validSlot.overlapWiths.forEach(over => {
          let topicTime = '';
          if (over.startTimeTopic) {
            topicTime = ` ${I18n.t('session_time_range', {
              date: formatCalendarBoundRange(
                over.startTimeTopic,
                over.endTimeTopic,
                'DD/MM/YY'
              ),
            })}`;
          }
          let { startDate } = over;
          const dateInWeek = changeDateUTCToLocale(startDate, over.startTimeSlot);
          startDate = dateInWeek ? dateInWeek : startDate;
          setOneSessionOverlapWiths(prev => [
            ...prev,
            {
              timeSlot: `${daysOfWeek()[startDate.toLowerCase()]} / ${convertToGMTLocal(over.startTimeSlot)} - ${convertToGMTLocal(over.endTimeSlot)}${topicTime}`,
              session: over.sessionName,
            }
          ]);
        });
      }
      setSaving(false)
      return;
    }
    createOneSlotSession({
        startDate: dayOfWeek.toLowerCase(),
        timeSlotStart: timeSlotStart,
        timeSlotEnd: timeSlotEnd,
        topicId: topicId,
        dataTime: { start: start, end: end },
      }).then((res) => {
      setSaving(false);
      if (res.status === 'OK') {
        toastSuccess(I18n.t('create_topic_successful'));
        window.location.reload();
      } else {
        toastError(res?.message ?? null)
      }
    })
  };

  const cancelConfig = () => {
    setIsShowModal(!isShowModal);
    setOpenModal(!isShowModal);
    setActiveDateCalendar(null);
    const resetEndTime = moment('08:00', 'HH:mm').add(topic?.duration || 45, 'minutes').format('HH:mm');
    setOneSessionTime({ start: '08:00', end: resetEndTime });
  };

  const handleChangeTime = (time) => {
    if (time) {
      const newStart = time.format('HH:mm');
      const newEnd = time.add(topic?.duration || 45, 'minutes').format('HH:mm');
      setOneSessionTime({ start: newStart, end: newEnd })
    }
  };

  return (
    <Modal
      id="modal-config-one-slot"
      size="lg"
      visible={isShowModal}
      dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <div className="d-flex align-items-center">
          <img
            className="cursor-pointer mr-3"
            src={arrowBackIcon}
            alt="Arrow Back"
            onClick={toggleOpenModal}
          />
          <span className="modal-title">{I18n.t('config_one_session')}</span>
        </div>
        <div className="section"></div>
        <div className="d-flex justify-content-center flex-column">
          <span>{I18n.t('config_one_session_step_1')} <small style={{ color: 'red' }}>*</small></span>
          <div ref={calendarRef}>
            <Calendar
              key={I18n.language}
              next2Label={null}
              prev2Label={null}
              {...getReactCalendarProps()}
              value={activeDateCalendar}
              minDetail={'month'}
              onClickDay={async (value) => {
                const inputDate = moment(value).startOf('day');
                const currentDate = moment().startOf('day');
                if (topic?.startTime && topic?.endTime) {
                  if (!isLocalDateInCalendarBounds(inputDate, topic.startTime, topic.endTime)) {
                    return null
                  }
                }
                if (inputDate.isBefore(currentDate)) {
                  return null;
                }
                setActiveDateCalendar(value);
              }}
              tileClassName={({ activeStartDate, date, view }) => {
                const inputDate = moment(date).startOf('day');
                const currentDate = moment().startOf('day');
                if (topic?.startTime && topic?.endTime) {
                  if (!isLocalDateInCalendarBounds(inputDate, topic.startTime, topic.endTime)) {
                    return 'can-not-register';
                  }
                }
                if (inputDate.isBefore(currentDate)) {
                  return 'can-not-register';
                }
                return 'can-register';
              }}
            />
            <div className="cld-footer"></div>
          </div>
        </div>
        {activeDateCalendar ?
          (
            <>
              <div className="section"></div>
              <span>{I18n.t('config_one_session_step_2', { date: moment(activeDateCalendar).format('DD/MM/YYYY') })}
                <small style={{ color: 'red' }}>*</small></span>
              <div className="d-flex align-items-center mt-4" style={{ gap: '12px' }}>
                <TimePicker
                  placeholder={null}
                  className="tlsi-picker"
                  suffixIcon={null}
                  allowClear={false}
                  onChange={(time) => handleChangeTime(time)}
                  value={moment(oneSessionTime.start, 'HH:mm')} format={'HH:mm'}
                />
                <span style={{ fontSize: '16px' }}>{I18n.t('to')}</span>
                <Tooltip title={I18n.t('config_session_tooltip_time')} placement="top">
                  <TimePicker
                    className="tlsi-picker"
                    placeholder={null}
                    disabled={true}
                    suffixIcon={null}
                    allowClear={false}
                    value={moment(oneSessionTime.end, 'HH:mm')} format={'HH:mm'}
                  />
                </Tooltip>
              </div>
              {oneSessionMessages && (
                <span className="error-message mt-1">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                  {oneSessionMessages}
                    </span>
              )}
              {oneSessionOverlapWiths?.length ? (
                <div className="d-flex justify-content-center flex-column">
                    <span className="error-message mt-1">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                      {I18n.t('session_date_time_error')}. {I18n.t('details')}
                    </span>
                  <div className="error-overlap mt-1">
                    {I18n.t('config_session_time_multi_hint')}
                    <ul className="mb-0 pl-3">
                      {oneSessionOverlapWiths?.map(over => (
                        <li>{I18n.t('config_session_overlap_hint', {
                          x: over.timeSlot,
                          y: over.session,
                        })}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : ''}
            </>)
          : null}
        <div className="section"></div>
        <div className="d-flex align-items-center justify-content-end">
          <button
            onClick={() => cancelConfig()}
            type="button"
            className="btn-time-slot cursor-pointer">
            {I18n.t('cancel')}
          </button>
          <button
            onClick={() => saveConfig()}
            type="button"
            disabled={saving}
            style={{
              color: saving ? '#888888' : '#000000',
              background: saving ? '#cccccc' : '#61E6BD',
              cursor: saving ? 'not-allowed' : 'pointer',
              border: 'none'
            }}
            className="btn-time-slot ml-4 cursor-pointer">
            {I18n.t('save')}
          </button>
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = ({ user, mvp }) => ({
  user, mvp,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    verifySlotSession,
    createOneSlotSession
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TopicDetailCreateOneSlot);
